import React from 'react';
import WorkspacesColumn from '../../components/ExpandableColumn/WorkspacesColumn';
import RecentColumn from '../../components/ExpandableColumn/RecentColumn';
import StarredColumn from '../../components/ExpandableColumn/StarredColumn';
import NotificationsColumn from '../../components/ExpandableColumn/NotificationsColumn';
import FeedbackColumn from '../../components/ExpandableColumn/FeedbackColumn';

const rightPanelContent = {
    navWorkspaces: (props) => <WorkspacesColumn {...props} />,
    navRecent: (props) => <RecentColumn {...props} />,
    navStarred: (props) => <StarredColumn {...props} />,
    notifications: (props) => <NotificationsColumn {...props} />,
    feedBack: (props) => <FeedbackColumn {...props} />,
    // Add more mappings as needed
};

export const getRightPanelContentById = (id, props) => rightPanelContent[id] ? rightPanelContent[id](props) : null;

// Content titles for the right panel header
export const getRightPanelTitle = (contentId) => {
    const titles = {
        navWorkspaces: 'Workspaces',
        navRecent: 'Recent Boards',
        navStarred: 'Starred Boards',
        notifications: 'Notifications',
        feedBack: 'Feedback',
    };
    return titles[contentId] || 'Panel';
};
